import { useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';
import packageJson from "../../package.json";
import { AuthUtils } from './auth.guard';
// ----------------------------------------------------------------------


export default function GuestGuard({ children }) {
  const { push, pathname } = useRouter();

  const { isAuthenticated, accessTokenState } = useAuth();

  useEffect(() => {
    if (isAuthenticated && pathname != "/gpshub") {
 
      push(PATH_DASHBOARD.root);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return <>{children}</>;
}
